<template>
  <div class="page-box">
    <PageSwiper location="BUSINESS" />

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div @click="gotoHome">首页 ></div>
      <div class="text">业务范畴</div>
    </div>

    <div class="biz-box">
      <div class="left-nav">
        <div
          class="nav-item"
          :class="{ 'nav-active': activeIndex == index }"
          v-for="(item, index) in bizData"
          :key="item.id"
          @mouseenter="navMouseEnter(index)"
        >
          <div>{{ item.subTitle | textFilter }}</div>
        </div>
      </div>

      <div class="right-content">
        <div class="title">{{ activeInfo.name }}</div>
        <div v-html="$utils.escape2Html(activeInfo.content)"></div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      bizData: [],
      activeIndex: 0,
      activeInfo: {}
    }
  },
  created() {
    if(this.$route.query?.realIndex) {
      this.activeIndex = this.$route.query?.realIndex
    }
    this.getBizData()
  },
  methods: {
    gotoHome() {
      if (localStorage.getItem('isFromHome') == 1) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    getBizData() {
      this.$http.getAction('/portal/api/v1/business/scope').then((res) => {
        if (res.success) {
          this.bizData = res.data
          if(res.data?.length > 0) {
            this.activeInfo = res.data[this.activeIndex]
          }
        }
      })
    },
    navMouseEnter(index) {
      console.log('进来了', index)
      if(index === this.activeIndex) return
      this.activeIndex = index
      this.activeInfo = this.bizData[index]
    }
    // gotoDetail(record) {
    //   this.$router.push({ name: 'bizScopeDetail', params: { id: record.id } })
    // }
  },
  filters: {
    textFilter(text) {
      if(text?.length > 10) {
        return text.slice(0, 10)
      }
      return text
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 70px;

  .page-nav {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 30px auto 70px;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    line-height: 16px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .biz-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    .left-nav {
      width: 300px;
      max-height: 560px;
      overflow-y: auto;
      background: #ffffff;
      box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 0px 0px;
      flex-shrink: 0;

      .nav-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 69px;
        border-bottom: 1px solid #d4d7d9;
        cursor: pointer;
        &:last-of-type {
          border-bottom: none;
        }
        div {
          white-space: nowrap;
          overflow: hidden;
          font-weight: 500;
          font-size: 20px;
          color: #000000;
        }
      }
      .nav-active {
        background: #0282de;
        div {
          // font-weight: 800;
          // font-size: 22px;
          color: #ffffff;
        }
      }
    }
    .right-content {
      flex: 1;
      padding: 0 70px;
      min-height: 600px;
      .title {
        padding: 15px 0;
        font-weight: 800;
        font-size: 26px;
        color: #000000;
        text-align: center;
      }
      .time {
        margin-top: 50px;
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 12px;
        color: #5a5a5a;
        line-height: 18px;
      }
    }
  }
}
</style>
